import React from 'react';
import PropTypes from 'prop-types';

const A11yAnnouncement = (props) => {
    const { message } = props;

    return (
        <span
            className="visually-hidden"
            aria-live="polite"
            aria-atomic="true"
        >
            {message}
        </span>
    );
};

A11yAnnouncement.propTypes = {
    message: PropTypes.string,
};

A11yAnnouncement.defaultProps = {
    message: '',
};

export default A11yAnnouncement;
